  <template>
  <div>
    <div class="table-responsive">
      <!-------------------- Tabla de REsultados -------------------->

      <table class="table table-hover">
        <thead>
          <tr>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="det in dataTabla.resumen" v-bind:key="det.id">
            <td>
              <div class="value">
                <small class="font-weight-bold">{{
                  det.producto__nombre
                }}</small>
              </div>
              <small
                ><div class="value">{{ det.producto_id }}</div></small
              >
              <h6 class="sub-value font-weight-bold">
                Conteo: {{ det.total }}
              </h6>
            </td>
            <td>
              <span class="sub-value">
                <small>
                  {{ det.fecha_conteo | moment("DD/MM/YYYY hh:mm a") }}</small
                >
              </span>
              <br />
              <h6
                v-if="dataTabla.fecha_finalizacion"
                class="sub-value font-weight-bold"
              >
                Teorica: {{ det.existencia_al_asignar }}
              </h6>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import Notifications from "@/notifications/notifications";

import Vue from "vue";
Vue.use(require("vue-moment"));

export default {
  components: {
    UsuarioEnTablaComponent,
    ProductoSelectComponentV2,
  },
  props: ["dataTabla"],
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      posiciones: [],
      searchtext: "",
      filtro_estado: "",
      currentDet: "",
      current: {
        producto: "",
        cantidad: 0,
        posicion: "",
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
